define(["marionette", "./template/generalConfigTemplate.html"], function (
  Marionette,
  GeneralConfigTemplate,
) {
  "use strict";

  return {
    view: Marionette.ItemView.extend({
      className: "form-horizontal",
      template: GeneralConfigTemplate,
      events: {
        "change #userDefaultKbs": function () {
          const optionSelected = this.$el.find("#userDefaultKbs option:selected").val();
          this.trigger("change:default:kb", optionSelected);
        },
        "change #userDefaultLanguages": function () {
          const optionSelected = this.$el.find("#userDefaultLanguages option:selected").val();
          this.trigger("change:interface:language", optionSelected);
        },
        "change #userDateFormat": function () {
          const optionSelected = this.$el.find("#userDateFormat option:selected").val();
          this.trigger("change:interface:dateFormat", optionSelected);
        },
        "change #showArchivedTopics": function () {
          const isChecked = this.$el.find("#showArchivedTopics").prop("checked");
          this.trigger("change:showArchivedTopics", isChecked);
        },
      },
      textboxes: {
        "#userNameText": {
          enableSelector: "#userNameText",
          modelAttribute: "userName",
          placeholder: "user.fullName",
          textArea: false,
        },
      },
    }),
  };
});
